import { PreloadedQuery } from 'react-relay';
import type { VariablesOf } from 'relay-runtime';

import { createRelayResource } from '@townsquare/relay-utils';
import { RouteResource } from '@townsquare/router/routing-types';
import type { ResourceContext } from '@townsquare/router/types';
import { getBooleanConfig } from '@townsquare/stat-sig/config';
import { tqlQueryFromInput } from '@townsquare/tql/query';
import { ComparatorOperator } from '@townsquare/tql/types';

import { DEFAULT_ENTITY } from '../components/FieldSettings/constants';
import SettingsViewQuery, {
	SettingsViewQuery as SettingsViewQueryType,
} from '../components/__generated__/SettingsViewQuery.graphql';

export const settingsPageResource: RouteResource<
	PreloadedQuery<SettingsViewQueryType, Record<string, unknown>>
> = createRelayResource<SettingsViewQueryType>({
	getQuery: (routerContext, resourceContext) => {
		const context = resourceContext as ResourceContext;
		const { entity, pageName } = routerContext.match.params;

		const isPersonalSettings = pageName === 'personal';
		const isWorkspaceSettings = pageName === 'workspace';
		const isFieldSettings = pageName === 'field';
		const isOnboardingSettingsEnabled = getBooleanConfig(
			'townsquare_enable_onboarding_edit_settings',
		);

		const fieldListTql = tqlQueryFromInput({
			input: [
				{
					fieldName: 'entityType',
					comparator: ComparatorOperator.EQUALS,
					fieldValue: entity?.toUpperCase() ?? DEFAULT_ENTITY,
				},
			],
		});
		const variables: VariablesOf<SettingsViewQueryType> = {
			id: context.workspace?.globalId ?? '',
			workspaceUuid: context.workspace?.UUID ?? '',
			tql: fieldListTql,
			isPersonalSettings,
			isWorkspaceSettings,
			isFieldSettings,
			isOnboardingSettingsEnabled,
		};

		return {
			query: SettingsViewQuery,
			variables,
		};
	},
});
